export default __webpack_public_path__ + "static/media/squares1300.43767b5a.jpg";